import React, { FC, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { parse } from "qs";

import { useAppDispatch } from "store";
import { tokenLoginAction } from "store/auth/auth.reducer";
import { PhoneVerification } from "./containers/PhoneVerification/PhoneVerification";
import styles from "./TokenLogin.module.scss";
import { Loader } from "pages/Loader/Loader";

const TokenLoginPage: FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const [confirmToken, setConfirmToken] = useState<string>();
  const [error, setError] = useState<string>("");

  const queryParams = useMemo(
    () => parse(location.search, { ignoreQueryPrefix: true }),
    [location.search]
  );

  const queryToken = useMemo(() => {
    if (!queryParams.token || typeof queryParams.token !== "string") {
      return null;
    }
    return queryParams.token;
  }, [queryParams.token]);

  useEffect(() => {
    if (queryToken) {
      dispatch(tokenLoginAction({ token: queryToken }))
        .then(({ token }) => {
          setConfirmToken(token);
        })
        .catch((e: string) => {
          setError(e);
        });
    }
  }, [queryToken]);

  if (!queryToken) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>Вход доступен только по ссылке</div>
      </div>
    );
  }
  if (error) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>{error}</div>
      </div>
    );
  }
  if (confirmToken) {
    return (
      <div className={styles.wrapper}>
        <PhoneVerification
          confirmToken={confirmToken}
          setConfirmToken={setConfirmToken}
        />
      </div>
    );
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper}>
        <Loader />
      </div>
    </div>
  );
};

export default TokenLoginPage;
